var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8773_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8773_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 16C13.7504 16 14.8129 15.5625 15.6879 14.6875C16.5629 13.8125 17.0004 12.75 17.0004 11.5C17.0004 10.25 16.5629 9.1875 15.6879 8.3125C14.8129 7.4375 13.7504 7 12.5004 7C11.2504 7 10.1879 7.4375 9.31289 8.3125C8.43789 9.1875 8.00039 10.25 8.00039 11.5C8.00039 12.75 8.43789 13.8125 9.31289 14.6875C10.1879 15.5625 11.2504 16 12.5004 16ZM12.5004 14.2C11.7504 14.2 11.1129 13.9375 10.5879 13.4125C10.0629 12.8875 9.80039 12.25 9.80039 11.5C9.80039 10.75 10.0629 10.1125 10.5879 9.5875C11.1129 9.0625 11.7504 8.8 12.5004 8.8C13.2504 8.8 13.8879 9.0625 14.4129 9.5875C14.9379 10.1125 15.2004 10.75 15.2004 11.5C15.2004 12.25 14.9379 12.8875 14.4129 13.4125C13.8879 13.9375 13.2504 14.2 12.5004 14.2ZM12.5004 19C10.2671 19 8.22956 18.4 6.38789 17.2C4.54622 16 3.09206 14.4167 2.02539 12.45C1.94206 12.3 1.87956 12.1458 1.83789 11.9875C1.79622 11.8292 1.77539 11.6667 1.77539 11.5C1.77539 11.3333 1.79622 11.1708 1.83789 11.0125C1.87956 10.8542 1.94206 10.7 2.02539 10.55C3.09206 8.58333 4.54622 7 6.38789 5.8C8.22956 4.6 10.2671 4 12.5004 4C14.7337 4 16.7712 4.6 18.6129 5.8C20.4546 7 21.9087 8.58333 22.9754 10.55C23.0587 10.7 23.1212 10.8542 23.1629 11.0125C23.2046 11.1708 23.2254 11.3333 23.2254 11.5C23.2254 11.6667 23.2046 11.8292 23.1629 11.9875C23.1212 12.1458 23.0587 12.3 22.9754 12.45C21.9087 14.4167 20.4546 16 18.6129 17.2C16.7712 18.4 14.7337 19 12.5004 19Z",
    fill: "#003460"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/view-eye.ff4522d8edec408a3c1bdca1ba67a4b7.svg";
export { ForwardRef as ReactComponent };